<template>
    <b-nav-item-dropdown variant="link" toggle-class="text-decoration-none" no-caret right>
        <template v-slot:button-content>
            <fa-icon-badge :icon="['fas', 'circle-user']" title="Account" :show-badge="showBadge"></fa-icon-badge>
            <span class="sr-only">Account</span>
        </template>
        <header-messages></header-messages>
        <b-dropdown-header>
            <div>
                <strong>{{ userFullName }}</strong>
            </div>
            <div>{{ userEmail }}</div>
        </b-dropdown-header>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-group class="lx-header-account-menu">
            <b-dropdown-item
                v-for="(item, index) in helpMenu"
                :key="'bdi' + index"
                :href="item.href"
                :target="item.target"
            >
                <font-awesome-icon :icon="['fas', 'caret-right']" size="sm"></font-awesome-icon>
                {{ item.text }}
            </b-dropdown-item>
        </b-dropdown-group>
        <b-dropdown-divider v-if="showHelpMenu"></b-dropdown-divider>
        <b-dropdown-group class="lx-header-account-menu">
            <b-dropdown-item href="/logout/">
                <font-awesome-icon :icon="['fas', 'caret-right']" size="sm"></font-awesome-icon>
                Logout
            </b-dropdown-item>
        </b-dropdown-group>
    </b-nav-item-dropdown>
</template>

<script>
    import FaIconBadge from '../../generic/fa-icon-badge/fa-icon-badge.vue';
    import HeaderMessages from './messages/header-messages.vue';
    import { mapGetters } from 'vuex';

    export default {
        name: 'HeaderAccount',
        components: {
            FaIconBadge,
            HeaderMessages,
        },
        computed: {
            ...mapGetters('header', [
                'userFullName',
                'userEmail',
                'workOrdersCount',
                'failedTransactionsCount',
                'undergoingResolutionTransactionsCount',
                'notificationsCount',
                'messagesTotal',
                'helpMenu',
                'helpMenuLength',
            ]),
            showBadge() {
                return this.messagesTotal > 0;
            },
            showHelpMenu() {
                return this.helpMenuLength > 0;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '~bootstrap/scss/_functions.scss';
    @import '~bootstrap/scss/_variables.scss';
    @import '~bootstrap/scss/mixins/_breakpoints.scss';

    @include media-breakpoint-down(md) {
        .dropdown {
            position: static;
        }

        :deep(.dropdown-menu) {
            position: absolute !important;
            right: 0;
            width: calc(100vw - 2rem);
            overflow: hidden;
        }
    }

    @include media-breakpoint-up(lg) {
        :deep(.dropdown-menu) {
            max-height: 80vh;
            overflow: auto;
        }
    }

    .lx-header-account-menu {
        padding: 0 0.5rem;
    }

    .lx-header-account-menu :deep(.dropdown-item .fa-sm) {
        margin-right: 0.5rem;
        vertical-align: initial;
    }

    /*
      Overwriting bootstrap style
     */
    :deep(.nav-link) {
        color: #ffffff !important;
    }

    :deep(.nav-link:hover),
    :deep(.nav-link:active) {
        color: rgba(255, 255, 255, 0.75) !important;
    }

    :deep(.nav-link) {
        padding-left: 0.5rem !important;
    }

    :deep(.dropdown-menu) {
        border-radius: 4px !important;
    }

    :deep(.dropdown-item) {
        padding: 0.5rem;
    }

    :deep(.dropdown-item:hover,.dropdown-item:active) {
        background-color: #4285f4;
        border-radius: 0.125rem;
        -webkit-box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15);
        box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15);
        color: #ffffff !important;
    }

    :deep(.dropdown-header) {
        padding: 0.5rem 1rem;
    }
</style>
